// !!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! GENERATED FILE. Do not edit manually. Run bin/generateLocalizedStrings.js instead
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
/* eslint-disable quotes */
export default {
  "ABOUT": "About",
  "ABOUT_API_TAB": "API",
  "ABOUT_VERSION": "Version",
  "ABOUT_EXTENSIS_URL": "www.portfoliodam.com",
  "ABOUT_PORTFOLIO_SERVER": "Portfolio Server",
  "ABOUT_PORTFOLIO_VERSION": "Version 9.0",
  "ABOUT_SERVER_TAB": "Server",
  "accessOriginals": "Access and Process Originals",
  "ACCOUNT_TYPE": "Authentication",
  "ACCOUNT_TYPE_LDAP": "Directory Service",
  "ACCOUNT_TYPE_MANUAL": "Native (Built-in)",
  "ACTIVE_DIRECTORY": "Active Directory",
  "ADD": "Add",
  "ALL_CATALOGS_GROUP": "All Catalogs",
  "API_CODE_REFERENCE": "API Code Reference (English)",
  "API_CODE_REFERENCE_URL": "https://doc.portfoliodam.com/api/portfolio/index.html",
  "API_DEVELOPER_COMMUNITY": "Developer Community",
  "API_DEVELOPER_COMMUNITY_URL": "https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community",
  "API_PORTFOLIO_HELP": "Portfolio Administration Help",
  "API_PORTFOLIO_HELP_URL": "https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm",
  "API_SECTION_1": "The Portfolio API provides a common interface for developers to integrate Portfolio catalogs, asset metadata, and media processing into business systems, custom workflows, and web infrastructures.",
  "API_SECTION_2_PART_1": "Use of the API requires licenses, as described in the",
  "API_SECTION_2_EULA": "Portfolio EULA",
  "API_SECTION_2_EULA_URL": "https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/Legal/extensis-portfolio-eula.htm",
  "API_SECTION_2_PART_2": ". To view or edit license information, click 'Licenses' in the Portfolio Administration application.",
  "API_SECTION_2_PART_3": "Learn more:",
  "API_TOKEN_CREATE": "Add New API Token",
  "APPLY": "Apply",
  "APP_PAGE_TITLE": "Portfolio Admin",
  "AT_TIME": "at",
  "AUTHENTICATION_ERROR": "Directory service authentication failed. Please check your username and password.",
  "BACKUP_BACKUP_BUTTON": "Backup",
  "BACKUP_BACKUP_LABEL": "Backup",
  "BACKUP_BACKUP_NOW_BUTTON": "Backup Now",
  "BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE": "To change the backup location, first shut down Portfolio server.",
  "BACKUP_CONFIRMATION_VERBIAGE": "Backup now? Portfolio will be offline until backup is complete.",
  "BACKUP_DIRECTORY_LABEL": "Store in Directory",
  "BACKUP_DIRECTORY_ERROR_MSG": "The selected backup directory is not valid.",
  "BACKUP_EXPLANATION_TEXT_1": "Backups capture and safely store the server database and settings.\nIt does not backup your original asset files!",
  "BACKUP_EXPLANATION_TEXT_2": "The server will be inaccessible during backups.",
  "BACKUP_FRIDAY_LABEL": "Friday",
  "BACKUP_MONDAY_LABEL": "Monday",
  "BACKUP_MOST_RECENT_LABEL": "Most Recent Backup",
  "BACKUP_NEXT_SCHEDULED_LABEL": "Next Scheduled Backup",
  "BACKUP_NOTIFICATIONS": "Send email notifications after backups and restores",
  "BACKUP_NOTIFICATIONS_DISABLED_MSG": "Email notifications must be enabled in Global Settings > Email Notifications",
  "BACKUP_PROGRESS_BACKING_UP": "Backing Up",
  "BACKUP_PROGRESS_BACKING_UP_DATA": "Backing up data...",
  "BACKUP_PROGRESS_BACKUP_CANCELLED": "Backup Cancelled",
  "BACKUP_PROGRESS_BACKUP_FAILED": "Backup Failed",
  "BACKUP_PROGRESS_BACKUP_SUCCESSFUL": "Backup Successful",
  "BACKUP_PROGRESS_PREFLIGHT": "Checking for available space...",
  "BACKUP_PROGRESS_RESTARTING": "Restarting server...",
  "BACKUP_PROGRESS_RESTORE_FAILED": "Restore Failed",
  "BACKUP_PROGRESS_RESTORE_SUCCESSFUL": "Restore Successful",
  "BACKUP_PROGRESS_RESTORING": "Restoring",
  "BACKUP_PROGRESS_RESTORING_DATA": "Restoring data...",
  "BACKUP_PROGRESS_SHUTTING_DOWN": "Shutting down server...",
  "BACKUP_PROGRESS_SUMMARY": "Step {stepNum} of {totalSteps}",
  "BACKUP_RESTORE_BUTTON": "Restore From Backup",
  "BACKUP_RESTORE_CONFIRMATION_VERBIAGE": "Restore backup now? Portfolio will be offline until restore is complete. This will overwrite your current database and settings.",
  "BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE": "The backup archive is corrupt.\nChoose another backup to restore from.",
  "BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE": "The backup disk has insufficient space\nto complete.\n\n{requiredSpace} required, {availableSpace} available.",
  "BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY": "The currently configured backup location does not exist. The backup location is used to unzip the archive when a backup is being restored. Please reset the backup location to a valid directory.",
  "BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP": "There was a problem with the backup.\nSee admin logs for details.",
  "BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE": "There was a problem with the restore.\nSee admin logs for details.",
  "BACKUP_RESTORE_LABEL": "Restore",
  "BACKUP_RESTORE_TITLE": "Backup/Restore",
  "BACKUP_RETAIN_LABEL": "Retain",
  "BACKUP_RETAIN_VALUE": "Keep only the {numBackups} most recent backups",
  "BACKUP_SATURDAY_LABEL": "Saturday",
  "BACKUP_SCHEDULE_LABEL": "Schedule Backups",
  "BACKUP_SCHEDULE_VALUE": "on",
  "BACKUP_SUNDAY_LABEL": "Sunday",
  "BACKUP_THURSDAY_LABEL": "Thursday",
  "BACKUP_TUESDAY_LABEL": "Tuesday",
  "BACKUP_WEDNESDAY_LABEL": "Wednesday",
  "BROWSE": "Browse",
  "BROWSE_FOLDERS_TITLE": "Browse Server Folders",
  "BROWSE_RECENT_FOLDERS_LABEL": "Recent Folders",
  "BROWSE_REFRESH": "Synchronize items",
  "CALL_ATT_BUTTON_BUY_NOW": "Buy Now",
  "CALL_ATT_BUTTON_SECONDARY": "Contact Sales for a Quote",
  "CALL_ATT_FADEL_BUTTON_MAIN": "Contact Sales for More Information",
  "CALL_ATT_FADEL_MAIN": "Ensure proper usage of your licensed content, from images to videos and everything in between. Portfolio seamlessly connects with FADEL Rights Cloud software so you can see and easily understand the usage rights associated with your assets—helping you to remove workflow bottlenecks and reduce the risk of expensive copyright violations.",
  "CALL_ATT_FADEL_SUBTITLE": "Know your asset usage rights",
  "CALL_ATT_FADEL_TITLE": "FADEL RIGHTS CLOUD",
  "CALL_ATT_ME_SUBTITLE": "High-Performance Processing and Conversion",
  "CALL_ATT_ME_MAIN": "Are you pushing the performance limits of your Portfolio server? With Media Engine, avoid slowdowns and improve overall productivity by eliminating the bottlenecks caused by busy production environments.\n\n\t• Increases capacity and throughput\n\t• Unlocks additional output formats\n\t• Accelerates video preview creation\n\t• Add multiple Media Engines as needed\n\t• Watermarking (requires NetPublish)",
  "CALL_ATT_ME_BUTTON_MAIN": "Get Media Engine",
  "CALL_ATT_NP_SUBTITLE": "Self-Service Portals to Access Assets Instantly",
  "CALL_ATT_NP_MAIN": "Tired of those last minute requests every time someone needs an asset? With NetPublish, it's easy to post self-serve websites that allow anyone to locate and download the assets they need from any browser on any device.\n\n\t• One-click site creation - no HTML or CSS required\n\t• Mobile-friendly, responsive design\n\t• Flexible user access control\n\t• Deactivate sites automatically\n\t• Set resolution, size and format on download\n\t• Watermarking (requires Media Engine)\n\t• Usage reporting",
  "CALL_ATT_NP_BUTTON_MAIN": "Get NetPublish",
  "CALL_ATT_REPORT_TITLE": "Reporting for NetPublish",
  "CALL_ATT_REPORT_SUBTITLE": "Relevant Usage Insight",
  "CALL_ATT_REPORT_MAIN": "Want to know which sites are most active, what assets are getting used and by whom? With NetPublish reporting, get the insight you need to make informed decisions based on how Portfolio is being used at your organization.\n\nUsage breakdown by:\n\t• NetPublish site name\n\t• Username\n\t• Asset name and ID\n\t• Date and time",
  "CALL_ATT_REPORT_BUTTON_MAIN": "Get NetPublish",
  "CALL_ATT_SK_BUTTON_MAIN": "Try it for Free",
  "CALL_ATT_SK_BUTTON_TRY_NOW": "https://extens.is/wqqb",
  "CALL_ATT_SK_MAIN": "Looking for a way to accelerate your process for assigning keywords to images? With Portfolio Smart Keywords, you can automatically assign “smart” keywords to your images with just one click. Powered by Clarifai, an innovative artificial intelligence company that excels in visual recognition technology, a list of suggested keywords is delivered in seconds.\n\n\t• Delivers a list of smart keywords in seconds\n\t• Saves time and resources by reducing manual keywording\n\t• Establishes a consistent taxonomy for your organization\n\t• Makes it easy to find your digital assets quickly",
  "CALL_ATT_SK_SUBTITLE": "Automate Your Image Keywording",
  "CALL_ATT_SK_TITLE": "Portfolio Smart Keywords",
  "CALL_ATT_SSO_SUBTITLE": "Seamless User Experience Across Platforms",
  "CALL_ATT_SSO_TITLE": "Single Sign-On",
  "CALL_ATT_SSO_MAIN": "Are people in your organization having a hard time keeping their login credentials straight? Typically, with new solutions come extra overhead in managing user accounts, both for you and for the users.\n\nFortunately, Portfolio supports Single Sign-On with Active Directory. Using Single Sign-On, users can login to Portfolio automatically from your intranet site giving them a continuous user experience.\n\n\t• Supports Windows Server Active Directory\n\t• Improves overall security\n\t• Simplifies user management\n\t• Improves user experience",
  "CALL_ATT_SSO_BUTTON_MAIN": "Get Single Sign-On",
  "CALL_ATT_URL_BUY_NOW": "https://secure.portfoliodam.com/portfolio-options",
  "CALL_ATT_URL_CONTACT_SALES": "https://portfoliodam.com/portfolio/contact-me",
  "canEmbedMetadata": "Embed Metadata",
  "canImportMetadata": "Import/Export Metadata",
  "canManagePublicGallery": "Manage Public Galleries",
  "canPublishNetPublishSites": "Publish NetPublish Sites",
  "canSmartKeyword": "Can Smart Keyword",
  "CANCEL": "Cancel",
  "CATALOG": "Catalog",
  "CATALOG_ADD_SELECTED_USERS_TO_CATALOG": "Grant Membership",
  "CATALOG_BACKUP": "Backup Selected Catalog",
  "CATALOG_CREATE": "Add New Catalog",
  "CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG": "Catalog Administrators can add AutoSync folders from the Desktop Client.",
  "CATALOG_CREATE_AUTOSYNC_FOLDER": "Create an AutoSync folder",
  "CATALOG_CREATE_CATALOG_TEMPLATE": "Save Catalog Template",
  "CATALOG_TYPE_GENERAL": "General Use",
  "CATALOG_TYPE_SIMPLE": "Simple",
  "CATALOG_CREATE_DATABASES_LIST_LABEL": "Databases",
  "CATALOG_CREATE_ERROR_CREATING_FOLDERS": "An error was encountered when creating the {folder} folder.",
  "CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG": "Default folders for AutoSync and Previews can be configured in Global Settings.",
  "CATALOG_CREATE_NAME": "Name",
  "CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG": "Previews can be configured in Catalog Details.",
  "CATALOG_CREATE_PREVIEW_FOLDER": "Save Previews for faster previewing",
  "CATALOG_CREATE_SHOW_DATABASES": "Show Databases",
  "CATALOG_CREATE_USE_VERSIONING": "Use Asset Versioning",
  "CATALOG_DELETE": "Delete Catalog",
  "CATALOG_DELETE_CONFIRM": "Do you want to delete the selected catalog?",
  "CATALOG_DETAILS": "Catalog Details",
  "CATALOG_DETAILS_CHANGE_NAME_PROMPT": "To rename this catalog we must temporarily take it offline, do you want to continue?",
  "CATALOG_DETAILS_COLLATION": "Collation",
  "CATALOG_DETAILS_COLLATION_NA": "N/A",
  "CATALOG_DETAILS_CREATION_DATE": "Creation Date",
  "CATALOG_DETAILS_DATABASE_TAB": "General",
  "CATALOG_DETAILS_LAST_MODIFIED": "Last Modified",
  "CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS": "Connected Users",
  "CATALOG_DETAILS_NUMBER_OF_RECORDS": "Records",
  "CATALOG_DETAILS_NUMBER_OF_USERS": "Members",
  "CATALOG_DETAILS_SIZE_ON_DISK": "Size on disk",
  "CATALOG_DETAILS_WARN_DISCONNECT_ADMIN": "The administrator user will be disconnected. Proceed?",
  "CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION": "Locked for administration",
  "CATALOG_DETAILS_UNLOCK": "Unlock",
  "CATALOG_EXPLANATION_VAULT_1": "Vault catalogs store assets in a secure repository.",
  "CATALOG_EXPLANATION_VAULT_2": "Vault catalogs support locking, versioning, check-out and check-in.",
  "CATALOG_EXPLANATION_WF_1": "Watch Folder catalogs track assets in place in your file system.",
  "CATALOG_EXPLANATION_WF_2": "Watch Folder catalogs support AutoSync.",
  "CATALOG_INGEST_DRAG_HINT_TEXT": "To add fields to the Upload Form, drag them over from the Fields list.",
  "CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL": "Fields for Upload Form",
  "CATALOG_INGEST_FIELDS_LABEL": "Fields",
  "CATALOG_INGEST_FORM_HEADER_LABEL": "Form Header",
  "CATALOG_INGEST_HEADER_HINT_TEXT": "The form header is optional and appears at the top of the form.",
  "CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE": "The maximum number of fields to add to a form is {maxFields}.",
  "CATALOG_INGEST_TAB_TITLE": "Managed Upload",
  "CATALOG_INGEST_USE_INGEST_LABEL": "Use Managed Upload",
  "CATALOG_INGEST_REQUIRED_LABEL": "Required",
  "CATALOG_IS_CONNECTED": "Connected",
  "CATALOG_IS_DEFAULT": "Default",
  "CATALOG_MANAGE_USERS": "Manage Catalog Membership",
  "CATALOG_MANAGE_FIELDS": "Manage Catalog Fields",
  "CATALOG_MANAGE_TEMPLATES_MENU_LABEL": "Manage Catalog Templates...",
  "CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE": "Manage Custom Catalog Templates",
  "CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER": "Catalog Template Name",
  "CATALOG_MEMBER": "Member",
  "CATALOG_NEW_CATALOG_DETAILS": "New Catalog Details",
  "CATALOG_OFFLINE": "Offline",
  "CATALOG_ONLINE": "Online",
  "CATALOG_OPTIONS_ALL_FILE_TYPES": "Catalog All File Types",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL": "Create Keywords from Path",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME": "Filename",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT": "Parent Folder",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER": "Server Name",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE": "Folder Tree",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME": "Volume",
  "CATALOG_OPTIONS_EXCLUSION_LABEL": "File and Folder Exclusions",
  "CATALOG_OPTIONS_ONLY_FILE_TYPES": "Catalog Only",
  "CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION": "Remove the selected file type(s)?",
  "endsWith": "Ends with",
  "contains": "Contains",
  "startsWith": "Starts with",
  "CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION": "Remove the selected exclusion(s)?",
  "CATALOG_OPTIONS_TAB_TITLE": "Cataloging Options",
  "CATALOG_PREVIEWS_DEFAULT_LOCATION_IS": "The default location is",
  "CATALOG_PREVIEWS_DIMENSIONS_LABEL": "Minimum size 300 pixels, maximum size 4000 pixel (longest dimension)",
  "CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES": "Generate clips for audio/video files",
  "CATALOG_PREVIEWS_GENERATE_PREVIEWS": "Create Previews",
  "CATALOG_PREVIEWS_FOLDER_LOCATION": "Save previews and clips in this folder",
  "CATALOG_PREVIEWS_LOCATION_WARNING_INFO": "This location must be accessible to the server.",
  "CATALOG_PREVIEWS_MAX_PIXELS": "Maximum image size",
  "CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION": "Maximum video resolution",
  "CATALOG_PREVIEWS_MINUTES": "minutes",
  "CATALOG_PREVIEWS_PIXELS": "pixels",
  "CATALOG_PREVIEWS_SHORT": "Previews",
  "CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION": "Limit duration to",
  "CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT": "Generating clips can take a while to process.\nTo shorten the processing time, choose a lower resolution and duration.",
  "CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG": "Revoke Membership",
  "CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION": "Remove the user from the catalog?\nThe user's Checked Out items in this catalog will be reverted and made accessible.",
  "CATALOG_SAVE_TEMPLATE": "Save Catalog Template...",
  "CATALOG_SAVE_TEMPLATE_DETAILS_TEXT": "Catalog templates include all fields, metadata mappings, and cataloging options.",
  "CATALOG_SELECT_MESSAGE": "No Catalog Selected",
  "CATALOG_SET_AS_DEFAULT": "Set Default Catalog",
  "CATALOG_SK_DEFAULT_SETTINGS": "Default Settings",
  "CATALOG_SK_CONFIDENCE_LEVEL_LABEL": "Confidence Level",
  "CATALOG_SK_DEFAULT_LABEL": "Recommended: {recommended}",
  "CATALOG_SK_ENGINES_LABEL": "Smart Keyword Engines",
  "CATALOG_SK_LANGUAGES_LABEL": "Languages for General Engine",
  "CATALOG_SK_NUM_KEYWORDS_LABEL": "Number of Keywords",
  "CATALOG_SK_SETTINGS_LABEL": "Settings",
  "CATALOG_SK_TAB_TITLE": "Smart Keywords",
  "CATALOG_SK_USE_SK_LABEL": "Use Smart Keywords in this Catalog",
  "CATALOG_STATUS": "Catalog Status",
  "CATALOG_STORAGE_TYPE_LABEL": "Storage Type",
  "CATALOG_STORAGE_TYPE_WATCHFOLDERS": "Watch Folders",
  "CATALOG_STORAGE_TYPE_VAULT": "Vault",
  "CATALOG_TAKE_OFFLINE_SHORT": "Take Offline",
  "CATALOG_TAKE_ONLINE_SHORT": "Take Online",
  "CATALOG_TEMPLATE": "template",
  "CATALOG_TEMPLATE_NAME": "Template Name",
  "CATALOG_TEMPLATES_TITLE": "Catalog Templates",
  "CATALOG_TEMPLATE_REMOVE_CONFIRMATION": "Remove the selected catalog template?",
  "CATALOG_VIEW_DETAILS": "View/Edit Catalog Details",
  "CERT_REQUEST_ALREADY_CREATED_WARNING": "You have already created a certificate request. If you continue, the existing request will be deleted.",
  "CERTIFICATE_FILE_FILTER": "Certificates (p7b, cer, crt, der, pfx, p12)",
  "CITY_OR_LOCALITY": "City or Locality",
  "CLEAR_BUTTON_LABEL": "Clear",
  "COMMUNICATION_AT_INITILIZATION_ERROR": "There was an error communicating with the server. This is usually caused by stale data in the browser cache but it could also indicate a problem with the server. Contact your administrator for more information.",
  "CONFIGURE_DIRECTORY_SERVICE": "Configure Directory Service",
  "CONFIRM_DELETE_PDL": "Delete all predefined values for this field?",
  "CONFIRM_DELETE_SERVICE": "Remove Directory Service?\nUsers imported from the service will remain. Their passwords will revert to values set previously in Portfolio, or will be disabled if not set previously.",
  "CONFIRM_TRUNCATE_VALUES": "Max Length exceeds one or more default or predefined values for this field. Truncate values?",
  "CONNECTION_REFUSED_ERROR": "The connection to the directory service was refused. Please check your hostname and port settings.",
  "CONTAINS": "contains",
  "CONTINUE": "Continue",
  "CREATE": "Create",
  "CREATE_A_CERTIFICATE_REQUEST": "Create a certificate signing request",
  "createContactSheet": "Make PDF",
  "CREATED_BY": "Created By",
  "CREATE_MAPPING": "Create Mapping",
  "CREATE_USER_EXCLUSION_MAPPING": "Exclude User",
  "CREATED_ON_DATE": "Date Created",
  "DATE_FORMAT": "MM/DD/YYYY",
  "DATE_FORMAT_ERROR": "Configuration error: Incorrect formatting string.",
  "DATE_INVALID_CHAR_ERROR": "The date contains invalid characters.",
  "DATE_TIME_FORMAT": "MM/DD/YYYY L:NN A",
  "DATE_TIME_SECONDS_FORMAT": "MM/DD/YYYY L:NN:SS A",
  "DATE_WRONG_DAY_ERROR": "Enter a valid day for the month.",
  "DATE_WRONG_LENGTH_ERROR": "Type the date in the format:",
  "DATE_WRONG_MONTH_ERROR": "Enter a month between 1 and 12.",
  "DATE_WRONG_YEAR_ERROR": "Enter a year between 0 and 9999.",
  "DEFAULT_ACCESS_LEVEL": "Default Role",
  "DEFAULT_CATALOG": "Default Catalog",
  "DEFAULT_CATALOG_NONE": "None",
  "DEFAULT_PORT_NON_SSL": "Default port for non-SSL:",
  "DEFAULT_PORT_SSL": "Default port for SSL:",
  "DELETE": "Delete",
  "DELETE_SOURCE": "Delete Source",
  "DELETE_ALL_NESTED_VALUES_CONFIRMATION": "Delete all values?\nThis will delete all values including nested values.",
  "DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION": "Delete the value '{value}'?\nIt contains nested values which will also be deleted.",
  "DELETE_NESTED_VALUE_CONFIRMATION": "Delete the selected values?\nThey contain nested values which will also be deleted.",
  "DELETE_WARNING_BOX_MSG": "Warning! Deleting cannot be undone!",
  "DELETE_WARNING_CATALOG_VAULT": "All files in the catalog will be destroyed.",
  "DIAGNOSTIC_DATA_TITLE": "Send Diagnostic Report to Portfolio DAM",
  "DIAGNOSTIC_DATA_ACCOUNT_NAME": "Company or Account Name (Required)",
  "DIAGNOSTIC_DATA_CONTACT_NAME": "Contact Name",
  "DIAGNOSTIC_DATA_TS_TICKET_NUMBER": "Tech Support Ticket Number",
  "DIAGNOSTIC_DATA_SEND_REPORT_BUTTON": "Send Report",
  "DIAGNOSTIC_STATUS_ERROR": "There was a problem uploading the diagnostic report on {date}",
  "DIAGNOSTIC_STATUS_SENDING": "Sending...",
  "DIAGNOSTIC_STATUS_SUCCESS": "Diagnostic report successfully sent to Portfolio DAM on {date}",
  "DIRECTORY_SERVICE_CONNECT_ERROR": "Unable to connect to the directory service. Please check the hostname and port settings.",
  "DIRECTORY_SERVICES": "Directory Services",
  "DIRECTORY_USERS_CANNOT_BE_DELETED": "Directory Service users cannot be deleted!",
  "DISTRIBUTION_GROUPS": "Distribution Groups",
  "DOWNLOAD_CERT_PROMPT": "Download certificate request file?",
  "DOWNLOAD_COMPLETE_STRING": "Download complete.",
  "downloadPreviews": "Download Previews",
  "EMAIL_ADDRESS": "Email Address",
  "EMAIL_CONFIG_AUTH_PASSWORD": "Password",
  "EMAIL_CONFIG_AUTH_USERNAME": "User Name",
  "EMAIL_CONFIG_ENABLED": "Enable Email Notifications",
  "EMAIL_CONFIG_FROM_ADDRESS": "Email From Address",
  "EMAIL_CONFIG_INVALID_GENERIC": "Email Server Configuration Invalid",
  "EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND": "Email Server Not Found",
  "EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED": "Email Server Authentication Failed",
  "EMAIL_CONFIG_MESSAGE": "Each user who wishes to receive notifications must have an email address assigned in the Users pane.",
  "EMAIL_CONFIG_SERVER_ADDRESS": "SMTP Server Address",
  "EMAIL_CONFIG_SERVER_PORT": "SMTP Server Port",
  "EMAIL_CONFIG_SUCCESS_MESSAGE": "SMTP Server Validated",
  "EMAIL_CONFIG_USE_SSL_TLS": "Use SSL / TLS",
  "EMAIL_CONFIG_USE_SMTP_AUTH": "Use SMTP Authentication",
  "EMAIL_CONFIG_VALIDATE": "Test Connection",
  "EMAIL_CONFIG_VALIDATED": "Email Server Validated",
  "english": "English",
  "ENTIRE_TREE_UNDER_SEARCH_BASE": "Entire tree",
  "EQUALS": "equals",
  "EXPORT_MENU_STRING": "Export Values",
  "FADEL_HOWTO": "Login to your FADEL account:",
  "FALSE_LABEL": "False",
  "FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR": "Please check that the admin server is running on your local machine on the port reflected on the ports page. If not, restart the server and reload this application.",
  "FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS": "This operation cannot be performed while a backup or restore is in progress.",
  "FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE": "That operation failed because the catalog is in admin mode.",
  "FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME": "A catalog already exists with this name.",
  "FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME": "A user already exists with this account name.",
  "FAULT_MSG_DB_IN_USE": "The operation could not be completed because the catalog is currently in use by an administrator.",
  "FAULT_MSG_DELETE_ADMIN": "You cannot delete the administrator account.",
  "FAULT_MSG_DELETE_SELF": "You cannot delete your user account.",
  "FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR": "An unexpected error occurred when deleting the catalog template.",
  "FAULT_MSG_DUPE_NAME": "An object with that name already exists.  Please use another name.",
  "FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS": "There is already a Media Engine with that address and port.",
  "FAULT_MSG_ENTITY_VERSION_MISMATCH": "That operation failed because the client's information was out of date.",
  "FAULT_MSG_IDENT_SERVICE_CREATION_ERROR": "Please check that the server is running on your local machine on the port reflected on the ports page. If not, restart the server and reload the application.",
  "FAULT_MSG_INVALID_SESSION_ID": "Your session has expired. You must log into the server again.",
  "FAULT_MSG_IS_NOT_LICENSED": "Server not licensed for that operation.",
  "FAULT_MSG_LEGACY_21000": "The operation failed because of an unknown internal error.",
  "FAULT_MSG_LOGGING_ERR_UPDATE": "There has been an error updating the logging configuration",
  "FAULT_MSG_LOG_DIR_NOT_VALID": "The specified log directory does not exist, is not writeable or the path specified is not a directory.",
  "FAULT_MSG_NO_DIRECTORY": "The specified location does not exist or it is not a directory.",
  "FAULT_MSG_NULL_DESCRIPTION": "An unexpected error occurred, but there is no description to report.",
  "FAULT_MSG_NULL_FAULTEVENT": "An unexpected error occurred, but there are no details to report.",
  "FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES": "That operation failed because you do not have sufficient privileges.",
  "FAULT_MSG_OPERATION_IS_INVALID": "That operation was not valid.",
  "FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR": "An unexpected error occurred when renaming the catalog template.",
  "FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR": "An unexpected error occurred when saving the catalog template.",
  "FAULT_MSG_SERVER_NOT_RUNNING": "The server is not running.",
  "FAULT_MSG_ENTERPRISE_NOT_LICENSED": "The operation failed because the server does not have an Enterprise Module license.",
  "FAULT_MSG_REMOVE_METADATA_DEF": "Removing the metadata definition failed.  It may be in use by other catalogs.",
  "FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT": "The server returned a fault with this message:",
  "FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE": "The server returned a fault with no error message.",
  "FAULT_MSG_UNHANDLED_UNKNOWN_FAULT": "The server returned a fault with an unknown type and this message:",
  "FAULT_MSG_UNKNOWN_SMTP_SERVER": "Unable to connect to the specified mail server.",
  "FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING": "That operation failed because a service was not in the expected state.",
  "FAULT_MSG_INVALID_LOGINID_OR_PASSWORD": "The username or password supplied for the database is not valid.",
  "FAULT_MSG_BAD_DB_PORT": "The database port specified is not valid.",
  "FAULT_MSG_BAD_DB_HOST": "The database hostname or port specified is invalid.",
  "FIELD_ACTION_ADD": "Add New Custom Field",
  "FIELD_ACTION_DELETE": "Delete Selected Field",
  "FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES": "XMP Namespaces",
  "FIELD_ACTION_MANAGE_METADATA": "Manage Metadata",
  "FIELD_CATEGORY_CUSTOM": "Custom Fields",
  "FIELD_CATEGORY_SYSTEM": "System Fields",
  "FIELD_CATEGORY_EXIF": "EXIF",
  "FIELD_CATEGORY_IPTC": "IPTC",
  "FIELD_CATEGORY_XMP": "XMP",
  "FIELD_CATEGORY_MOVIE": "Movie",
  "FIELD_CATEGORY_OFFICE": "MS Office",
  "FIELD_CATEGORY_GEO": "GEO",
  "FIELD_CATEGORY_LABEL": "Field Category",
  "FIELD_DISABLE_CONFIRM_MSG": "Do you want to disable the selected field?",
  "FIELD_ENABLE_ALL_CATEGORIES_LABEL": "Enable All",
  "FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING": "Add Extract Mapping",
  "FIELD_FORM_LABEL_DEFAULT_VALUE": "Default Value",
  "FIELD_FORM_LABEL_DISABLED": "(Disabled)",
  "FIELD_FORM_LABEL_EMBED": "Embed in Metadata",
  "FIELD_FORM_LABEL_EXTRACT": "Extract from Metadata",
  "FIELD_FORM_LABEL_FIELD_NAME": "Field Name",
  "FIELD_FORM_LABEL_FIELD_TYPE": "Field Type",
  "FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES": "Allow Multiple Values",
  "FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES": "Has Predefined Values",
  "FIELD_FORM_LABEL_HELP_TEXT": "Help Text",
  "FIELD_FORM_LABEL_MAX": "Max: {max}",
  "FIELD_FORM_LABEL_MAX_LENGTH": "Max Length",
  "FIELD_FORM_LABEL_METADATA_TAG": "Metadata Name",
  "FIELD_FORM_LABEL_METADATA_TYPE": "Metadata Type",
  "FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES": "Allow Only Predefined Values",
  "FIELD_FORM_LABEL_PRECISION": "Precision",
  "FIELD_FORM_LABEL_PREDEFINED_VALUES": "Predefined Values",
  "FIELD_FORM_LABEL_SHOW_TIME": "Show Time",
  "FIELD_FORM_LABEL_USE_METADATA": "Extract and Embed Metadata",
  "FIELD_FORM_WARNING_DUPE_EMBEDS": "Warning: More than one field embeds to '{metadata}'",
  "FIELD_METADATA_DATA_TYPE_LABEL": "Data Type",
  "FIELD_METADATA_DEFINITION_IS_CUSTOM": "Is Custom",
  "FIELD_METADATA_DEFINITIONS_TITLE": "Metadata Definitions",
  "FIELD_METADATA_DELETE_CONFIRM_MSG": "Confirm: Delete the Metadata Definition?",
  "FIELD_METADATA_MULTIVALUED_TYPE_LABEL": "Multivalued Type",
  "FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL": "Not Multivalued",
  "FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL": "Ordered",
  "FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL": "Unordered",
  "FIELD_METADATA_NAME_LABEL": "Name",
  "FIELD_METADATA_NAMESPACE_LABEL": "Namespace",
  "FIELD_METADATA_NEW_NAMESPACE_TOOLTIP": "Add a Custom XMP Namespace...",
  "FIELD_METADATA_TAG_LABEL": "Tag",
  "FIELD_METADATA_TYPE_LABEL": "Type",
  "FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE": "Multiple Fields Selected",
  "FIELD_NAMESPACE_ABBREVIATION": "Abbreviation",
  "FIELD_NAMESPACE_REMOVE_CONFIRMATION": "Delete the Custom XMP Namespace?\nThere may be Field Definitions using the namespace.",
  "FIELD_NAMESPACE_URI": "Namespace URI",
  "FIELD_NEW_FIELD_NAME": "New Field",
  "FIELD_NEW_METADATA_TITLE": "New Metadata Definition",
  "FIELD_NEW_NAMESPACE_TITLE": "New Custom XMP Namespace",
  "FIELD_NO_FIELD_SELECTED_MESSAGE": "No Field Selected",
  "FIELD_PAGE_TITLE": "Manage Fields for Catalog '{catalogName}'",
  "FIELD_REVERT_CONFIRM_MSG": "Confirm: Revert the field?",
  "FIELD_TYPE_BLOB": "Blob",
  "FIELD_TYPE_BOOLEAN": "Boolean",
  "FIELD_TYPE_DATETIME": "Date/Time",
  "FIELD_TYPE_DECIMAL": "Decimal",
  "FIELD_TYPE_LANG_ALT": "Lang Alt",
  "FIELD_TYPE_NUMBER": "Number",
  "FIELD_TYPE_PICTURE": "Picture",
  "FIELD_TYPE_STRING": "String",
  "FIELD_TYPE_STRUCTURE": "Structure",
  "FIELD_TYPE_TEXTBLOCK": "Text Block",
  "FIELD_TYPE_UNKNOWN": "Unknown",
  "FIELD_TYPE_URL": "URL",
  "FILE_IO_ERROR_MSG": "There was an error uploading the file to the server.",
  "FILE_WRONG_TYPE_ERROR_MSG": "This file is not a supported file type.\nPlease select a jpeg, gif or png file.",
  "FOLDER_PATH_AUTOSYNC_FILES_STRING": "Files",
  "FOLDER_PATH_ALREADY_EXIST_AS_FILE": "A file exists with this name.",
  "FOLDER_PATH_DOES_NOT_EXIST": "Path does not exist.",
  "FOLDER_PATH_ERROR": "Error",
  "FOLDER_PATH_NOT_VERIFIED": "The folder path has not been verified.",
  "FOLDER_PATH_PATH": "Path",
  "FOLDER_PATH_OPERATION_INVALID": "An invalid operation",
  "FOLDER_PATH_SUCCESS": "Success",
  "FOLDER_PATH_TYPE_AUTOSYNC": "autosync",
  "FOLDER_PATH_TYPE_PREVIEW": "preview",
  "FOLDER_PATH_UNKNOWN_FAULT": "An unknown fault",
  "french": "French",
  "FULL_NAME": "Full Name",
  "FULLY_QUALIFIED_DOMAIN_NAME": "Fully Qualified Domain Name",
  "german": "German",
  "GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL": "Create AutoSync folders for new catalogs in this folder",
  "GLOBAL_SETTINGS_BACKGROUND_COLOR": "Background Color",
  "GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP": "Background color of the login screen.",
  "GLOBAL_SETTINGS_CATALOG_DEFAULTS": "Catalog Defaults",
  "GLOBAL_SETTINGS_CHOOSE_FILE": "Choose File",
  "GLOBAL_SETTINGS_CUSTOM_IMAGE": "Custom Image",
  "GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT": "Approximate size should fit within 2400 x 1350 pixels.",
  "GLOBAL_SETTINGS_CUSTOM_TITLE": "Custom Title",
  "GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP": "The title that appears on the browser tab or bookmark.",
  "GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN": "Customized Login Screen",
  "GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL": "Default Role",
  "GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN": "Default Login Screen",
  "GLOBAL_SETTINGS_EMAIL_CONFIGURATION": "Email Notifications",
  "GLOBAL_SETTINGS_FADEL": "FADEL Rights Cloud",
  "GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG": "The location of AutoSync and Preview folders must be accessible to the server.",
  "GLOBAL_SETTINGS_IMAGE_URL": "Link",
  "GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP": "Clicking the image will launch this URL in another browser window.",
  "GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG": "To make changes, start the server or check for an expired server license.",
  "GLOBAL_SETTINGS_PREVIEW_PATH_LABEL": "Save Previews for new catalogs in this folder",
  "GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS": "Server Data Locations",
  "GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION": "Portfolio Login Customization",
  "GLOBAL_SETTINGS_SSO_CREDENTIALS": "Single Sign-on Credentials",
  "GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP": "Enter the user account that is associated with the Portfolio Server service for Kerberos authentication.",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL": "Temporary Work folder",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG": "The work folder will be changed the next time the server is restarted. The new folder will be located at:",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG": "You must restart the server for this change to take effect.",
  "GLOBAL_SETTINGS_VAULT_CONFIGURATION": "Portfolio Vault Configuration",
  "GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL": "Portfolio Vault folder",
  "SERVER_DATA_DEFAULT_VAULT_LOCATION_IS": "Default:",
  "GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE": "To move Portfolio Vault folder, first shut down Portfolio server.",
  "HELP_URL": "https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm",
  "HELP_URL_FADEL": "https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/03_Catalogs/05_FADEL.htm",
  "HOSTNAME": "Hostname",
  "IDENTITY_SERVICE_DEFAULT_ROLE_STRING": "(default)",
  "IDENTITY_SERVICE_SUCCESSFUL_CREATION": "Directory Service connection succeeded. Configuration saved.",
  "IMAGE_FILE_FILTER": "Images (jpg, gif, png)",
  "IMPORT_LDAP": "Import users from LDAP/AD server",
  "IMPORT_LDAP_SPECIFY_SERVER": "Specify LDAP/AD Server",
  "IMPORT_MENU_STRING": "Import Values",
  "IMPORT_SOURCE": "Import Source",
  "INVALID_DN_SYNTAX_ERROR": "Unable to connect to the directory service due to invalid DN syntax error. Please check the username.",
  "japanese": "Japanese",
  "LAST_CERTIFICATE_REQUEST_LABEL": "Last Certificate Request",
  "LAST_MODIFIED_BY": "Last Modified By",
  "LAST_MODIFIED_DATE": "Date Last Modified",
  "LDAP_ADDRESS": "LDAP/AD Server address",
  "LDAP_BIND_USERNAME": "LDAP Bind Username",
  "LDAP_SYNC_NOTIFICATION": "The server has received the sync request.",
  "LIC_ADD_MESSAGE": "Copy and Paste Licenses or enter individually one per row.",
  "LIC_ADD_SN": "Add New License",
  "LIC_ADD_SN_SHORT": "Add Licenses",
  "LIC_ASSET_CAP_DISPLAY": "Assets",
  "LIC_DAYS_REMAINING": "({days} Days Remaining)",
  "LIC_DEMO_PERIOD": "Demo Period",
  "LIC_ERROR_MSG": "Invalid serial number, please re-try. If the problem persists check your server log or contact your administrator.",
  "LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG": "The serial number cannot be added to Portfolio Studio.",
  "LITE_CANNOT_CREATE_FDB_CATALOG": "Your Portfolio license does not allow more than one catalog. Please consider upgrading your Portfolio license to perform this action.",
  "LITE_CANNOT_SERVE_FDB_CATALOG": "Your Portfolio Server license does not allow further catalogs to be taken online.",
  "LITE_THIS_FEATURE_NOT_SUPPORTED": "Your Portfolio Server license does not support this action.",
  "LOGGING_CONFIGURATION": "Logging Configuration",
  "LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE": "To move Logs folder, first shut down Portfolio server.",
  "LOGGING_DEFAULT_LOCATION_MSG": "The default log location is",
  "LOGGING_DIR_MUST_EXIST": "NOTE: In order to successfully change the log directory, the newly specified directory must already exist and be writeable by the user under which the Portfolio Server is running.",
  "LOGGING_LOG_DIR": "Logs folder",
  "LOGGING_LOG_LEVEL": "Log level",
  "LOGGING_NUM_LOGS_TO_RETAIN": "Number of logs to retain",
  "LOGIN": "Login",
  "MAPPING_HEADER": "User/Group Mapping to Portfolio",
  "MAPPINGS_HAVE_BEEN_MODIFIED_ALERT": "The mappings have been modified, would you like to save them?",
  "MEDIA_ENGINES_ACTION_ADD": "Add New Media Engine",
  "MEDIA_ENGINES_ACTION_DELETE": "Delete Media Engine",
  "MEDIA_ENGINES_ACTION_EDIT": "View/Edit Media Engine Details",
  "MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE": "You can not add another active Media Engine because the server is already using the maximum number of active media engines allowed by your Portfolio Media Engine license.",
  "MEDIA_ENGINES_CANT_ADD_NO_LICENSES": "You can not add a Media Engine because the server doesn't have any available Portfolio Media Engine licenses.",
  "MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER": "You can not remove the built in Media Engine.",
  "MEDIA_ENGINES_COLUMN_ACTIVE": "Active",
  "MEDIA_ENGINES_COLUMN_ADDRESS": "Address",
  "MEDIA_ENGINES_COLUMN_PORT": "Port",
  "MEDIA_ENGINES_CONFIRM_DELETE": "Do you want to delete the selected Media Engine?",
  "MEDIA_ENGINES_EDIT_DETAILS_HEADER": "Media Engine Details",
  "MEDIA_ENGINES_LICENSES_LABEL": "Media Engine seats available for activation",
  "MEDIA_ENGINES_NEW_DETAILS_HEADER": "New Media Engine Details",
  "MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE": "No Media Engines are active. You should activate a Media Engine before clients need to use Portfolio Media services.",
  "MOBILE": "Mobile",
  "MOBILE_ENABLED": "Enable Mobile Uploading",
  "MOBILE_FOLDER_VERBIAGE": "Save mobile uploads to this folder:",
  "MOBILE_CREATE_CATALOG_VERBIAGE": "Create new catalog 'Mobile Uploads' to automatically watch this folder (recommended)",
  "MOBILE_CATALOG_NAME": "Mobile Uploads",
  "modifyAssetContents": "Check Out Assets",
  "MODIFY_LDAP": "Modify LDAP query",
  "NAME": "Name",
  "NAME_TOO_LONG_ERROR": "Name must be less than 256 characters.",
  "NAV_ABOUT": "About",
  "NAV_ACCESS_LEVELS": "Roles",
  "NAV_AUTOSYNC": "Autosync",
  "NAV_BACKUPS": "Backup/Restore",
  "NAV_CATALOGS": "Catalogs",
  "NAV_GLOBAL_SETTINGS": "Global Settings",
  "NAV_HELP": "Help",
  "NAV_LICENSES": "Licenses",
  "NAV_LOGOUT": "Logout",
  "NAV_MEDIA_ENGINES": "Media Engines",
  "NAV_NETPUBLISH_SETTINGS": "NetPublish",
  "NAV_PORTS": "Ports",
  "NAV_REPORTING": "Reports",
  "NAV_SETTINGS": "Settings",
  "NAV_STATUS": "Status",
  "NAV_USERS": "Users",
  "NO_CATALOGS": "None",
  "NO_FILE_SELECTED": "No File Selected",
  "VaultFolderNotFound": "The Portfolio Vault folder was not found at {path}.",
  "NO_VAULT_FOLDER": "The Portfolio Vault folder was not found at {path}.\n\nPlease check the location of the folder on your file system, and in the Global Settings -> Server Data page of this application.",
  "NOTES": "Notes",
  "NUMBER_DECIMAL_POINT_COUNT_ERROR": "The decimal separator can only occur once.",
  "NUMBER_EXCEEDS_MAX_ERROR": "The number entered is too large.",
  "NUMBER_INTEGER_ERROR": "The number must be an integer.",
  "NUMBER_INVALID_CHAR_ERROR": "The input contains invalid characters.",
  "NUMBER_INVALID_FORMAT_CHARS_ERROR": "One of the formatting parameters is invalid.",
  "NUMBER_LOWER_THAN_MIN_ERROR": "The amount entered is too small.",
  "NUMBER_NEGATIVE_ERROR": "The amount may not be negative.",
  "NUMBER_PRECISION_ERROR": "The amount entered has too many digits beyond the decimal point.",
  "NUMBER_SEPARATION_ERROR": "The thousands separator must be followed by three digits.",
  "OK": "OK",
  "ON_DATE": "on",
  "OPEN_DIRECTORY": "Open Directory",
  "OPEN_DIRECTORY_GROUPS": "Groups",
  "ORGANIZATION_NAME": "Organization Name",
  "ORGANIZATIONAL_UNIT": "Organizational Unit",
  "PASSWORD": "Password",
  "PASSWORD_CONFIRM": "Confirm Password",
  "PASSWORD_TOO_LONG_ERROR": "Password must be less than 256 characters.",
  "PORT": "Port",
  "PORT_VALUE_TOO_HIGH_ERROR": "Port value must be less than 65536.",
  "PortfolioAssetCap": "Portfolio Asset Cap",
  "PortfolioAPI": "Portfolio API",
  "PortfolioDemo": "Demo",
  "PortfolioDirServices": "Portfolio Directory Services",
  "PortfolioServer": "Portfolio Server",
  "PortfolioStudio": "Portfolio Studio Edition",
  "PortfolioProfessional": "Portfolio Professional Edition",
  "PortfolioEnterprise": "Portfolio Enterprise Edition",
  "PortfolioMediaEngine": "Portfolio Media Engine",
  "NetPublish": "Portfolio NetPublish",
  "PortfolioMobile": "Portfolio Flow",
  "PortfolioSmartKeywords": "Portfolio Smart Keywords",
  "PortfolioUserConnection": "Portfolio User Connection",
  "PortfolioSingleSignOn": "Single Sign On (SSO)",
  "PORT_CURRENT_VALUE": "Current Value",
  "PORT_ERROR_MSG_BAD_PORT_VALUE": "The new port value must be a number between 1 and 65535.",
  "PORT_ERROR_MSG_CONFLICT": "Can not update port values because one or more of the new port values is already in use on the server.",
  "PORT_FIND_PORT": "Find Port",
  "PORT_NAME": "Name",
  "PORT_NEW_VALUE": "New Value",
  "PORT_RESTART_NOTICE": "Note: port updates do not take effect until the server is restarted.",
  "PORT_RESTART_SERVER": "Restart Server",
  "PORT_UPDATE_PORTS": "Update Ports",
  "PORT_WARNING_ADMIN_RESTART": "The admin port was changed. The browser will be redirected to the new location in {numSecs} seconds.",
  "PREVIEW_MAX_VIDEO_RESOLUTION_360": "360p",
  "PREVIEW_MAX_VIDEO_RESOLUTION_480": "480p",
  "PREVIEW_MAX_VIDEO_RESOLUTION_540": "540p HD",
  "PREVIEW_MAX_VIDEO_RESOLUTION_720": "720p HD",
  "PREVIEW_MAX_VIDEO_RESOLUTION_1080": "1080p HD",
  "PROMPT_ARE_YOU_SURE": "Are you sure?",
  "PROMPT_COULD_NOT_CREATE_FOLDER": "That folder could not be created. Please enter another path.",
  "PROMPT_COULD_NOT_CREATE_FOLDERS": "Please enter another folder path because the following paths could not be created:",
  "PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT": "That folder could not be created because there's already a file with that name. Please enter another path.",
  "PROMPT_CREATE_THAT_FOLDER": "That folder does not exist. Create it?",
  "PROMPT_CREATE_THESE_FOLDERS": "These folders do not exist. Do you want to create them?",
  "PROMPT_DELETE_LICENSE_CONFIRM": "Do you want to delete the selected license?",
  "QUERY": "Query",
  "REMOVE": "Remove",
  "REMOVE_DIRECTORY_SERVICE": "Remove Service",
  "REPLACE_USER_MAPPING_CONFIRMATION": "A regular user mapping already exists for this user. Replace it with an exclude user mapping?",
  "REPLACE_USER_EXCLUSION_CONFIRMATION": "An exclude user mapping already exists for this user. Replace it with a regular user mapping?",
  "REQUIRED_FIELD_ERROR": "This field is required.",
  "REVERT": "Revert",
  "REVERT_CHANGES": "Revert Changes",
  "ROLE_FOR_IMPORT": "Role for Import",
  "ROLES_PERMISSION_ENABLED_HEADER": "Enabled",
  "ROLES_PERMISSION_NAME_HEADER": "Operation",
  "SAVE": "Save",
  "SAVE_MAPPING": "Save Mapping",
  "saveOutputSetting": "Manage Presets (Convert and Make PDF)",
  "SEARCH": "Search",
  "SEARCH_BASE": "Search Base",
  "SEARCH_RESULTS": "Search Results",
  "SECURITY_GROUPS": "Security Groups",
  "SELECT": "Select",
  "SEND_DIAGNOSTIC_DATA": "Send diagnostic report to Portfolio DAM",
  "SERVER_DATA_DEFAULT_WORK_LOCATION_IS": "Default work location:",
  "SERVER_RESTART_REQUIRED": "The server must be restarted for changes to take effect.",
  "SERVER_STATE_ERROR": "Error: See Admin Log for Details",
  "SERVER_STATE_STARTED": "Running",
  "SERVER_STATE_STARTING": "Starting",
  "SERVER_STATE_STOPPED": "Stopped",
  "SERVER_STATE_STOPPING": "Stopping",
  "SERVER_STATE_UNKNOWN": "Unknown",
  "SERVICE_BROWSER": "Service Browser",
  "SK_ENGINE_APPAREL": "Apparel",
  "SK_ENGINE_CELEBRITIES": "Celebrities",
  "SK_ENGINE_FOOD": "Food",
  "SK_ENGINE_GENERAL": "General",
  "SK_ENGINE_LOGO": "Logo",
  "SK_ENGINE_MODERATION": "Moderation",
  "SK_ENGINE_NSFW": "NSFW",
  "SK_ENGINE_TRAVEL": "Travel",
  "SK_ENGINE_WEDDINGS": "Weddings",
  "SSL_HANDSHAKE_ERROR": "SSL handshake failed; please verify that the port and SSL settings are correct.",
  "STARTS_WITH": "starts with",
  "STATE_OR_PROVINCE": "State or Province",
  "STATUS": "Status",
  "STATUS_ADMIN_LOG": "Admin Log",
  "STATUS_API_VERSION_LABEL": "API",
  "STATUS_API_STATE_LICENSED": "Licensed",
  "STATUS_API_STATE_UNLICENSED": "Not licensed",
  "STATUS_CLEAR_ADMIN_LOG": "Clear Admin Log",
  "STATUS_CONNECTED_USERS": "Connected Users",
  "STATUS_MAX_ALLOWED_CONNECTIONS": "Maximum Connections",
  "STATUS_MEDIA_ENGINE_VERSION_LABEL": "Media Engine",
  "STATUS_MEDIA_ENGINES_ACTIVE": "Active",
  "STATUS_MEDIA_ENGINES_LABEL": "Media Engines",
  "STATUS_RESTART_SERVER": "Restart Portfolio",
  "STATUS_SEAT_USAGE": "Seat Usage",
  "STATUS_SERVER_STATE": "Portfolio State",
  "STATUS_SERVER_VERSION_LABEL": "Portfolio",
  "STATUS_START_SERVER": "Start Portfolio",
  "STATUS_STOP_SERVER": "Stop Portfolio",
  "STATUS_PROBLEMS_DETECTED": "Problems detected:",
  "STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM": "Remaining startup disk space is under {minSpace}GB.",
  "STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST": "The work folder does not exist or is inaccessible.",
  "STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE": "The Portfolio server cannot write to the work folder.",
  "STATUS_MSG_WORK_FOLDER_NOT_READABLE": "The Portfolio server cannot read from the work folder.",
  "STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE": "The Portfolio server cannot create symlinks in the work folder.",
  "STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW": "Remaining work folder disk space is under {minSpace}GB.",
  "STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS": "Unable to get work folder status.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED": "The status for elasticsearch index {index} is red.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS": "The elasticsearch index {index} has uninitialized shards.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE": "Not all shards are active for the elasticsearch index {index}.",
  "STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS": "Unable to retrieve elasticsearch status.",
  "STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER": "Unable to retrieve errors from the Portfolio server.",
  "STATUS_MSG_STARTUP_FAILED": "Startup failed",
  "STATUS_MSG_CANT_GET_SERVER_HEALTH": "Unable to update server health.",
  "STATUS_MSG_NATIVE_AGENT_NOT_RUNNING": "The native-agent server component is not running.",
  "SUBJECT_ALTERNATIVE_NAMES": "Subject Alternative Names",
  "SUBMIT": "Submit",
  "swedish": "Swedish",
  "SYNC_DAILY": "Synchronize Daily",
  "SYNCHRONIZE_NOW": "Synchronize Now",
  "TARGET_CATALOG": "Target Catalog",
  "THIS_LOCALE": "en",
  "TRUE_LABEL": "True",
  "TOKEN": "Token",
  "TOTAL_ASSETS": "Total Assets",
  "TWO_LETTER_COUNTRY_CODE": "Two-letter Country Code",
  "TYPE": "Type",
  "UNABLE_CONNECT_LDAP": "Unable to connect to LDAP/AD server.",
  "UNABLE_CONNECT_SERVER": "Unable to connect to server.",
  "UNKNOWN_HOST_ERROR": "Unable to connect to directory service due to an unknown host exception. Please check the hostname.",
  "UNKNOWN_LDAP_USER_ERROR": "No user was found in the Identity Service with the account name '{accountName}'.",
  "useCustomPresets": "Use Convert Presets",
  "USE_SSL": "Use SSL",
  "USER_ACCOUNT": "Account",
  "USER_CREATE": "Add New User",
  "USER_DELETE": "Delete Users",
  "USER_DELETE_CONFIRM": "Delete Selected Users?",
  "USER_DELETE__DELETE_PRIVATE": "Permanently Deleted",
  "USER_DELETE__GALLERY_PROMPT": "Make Public makes all private and read-only galleries that belong to this user, public galleries. \"Delete All Private Galleries\" permanently removes private galleries, and makes read-only galleries public.",
  "USER_DELETE__GALLERY_PROMPT_1": "The users' Checked Out items will be reverted and made accessible.",
  "USER_DELETE__GALLERY_PROMPT_2": "The users' Read-Only Galleries will be made Public.",
  "USER_DELETE__GALLERY_PROMPT_3": "The users' Private Galleries should be:",
  "USER_DELETE__MAKE_PUBLIC": "Made Public",
  "USER_DETAILS": "User Details",
  "USER_IMPORT": "Import Users",
  "USER_IMPORT_ACCOUNT": "Account Name",
  "USER_IMPORT_ACCOUNT_ATTR": "Account Attribute",
  "USER_IMPORT_EMAIL_ATTR": "Email Attribute",
  "USER_IMPORT_IMPORT": "Import",
  "USER_IMPORT_IMPORT_SELECTED_USERS": "Import Selected Users",
  "USER_IMPORT_MODIFY_SEARCH": "Modify Search",
  "USER_IMPORT_NAME_ATTR": "Account Name Attribute",
  "USER_IMPORT_NOTES_ATTR": "Notes Attribute",
  "USER_IMPORT_PASSWORD": "Account Password",
  "USER_IMPORT_PASSWORD_ATTR": "Password Attribute",
  "USER_IMPORT_SEARCH": "Search",
  "USER_IMPORT_SEARCH_BASE": "Search Base",
  "USER_IMPORT_SEARCH_FILTER": "Search Filter",
  "USER_IMPORT_SERVER_ADDRESS": "Server Address",
  "USER_IMPORT_SPECIFY_LDAP_SERVER": "Specify LDAP Server",
  "USER_LEVEL_ADMINISTRATOR": "Catalog Administrator",
  "USER_LEVEL_EDITOR": "Editor",
  "USER_LEVEL_NON_MEMBER": "--",
  "USER_LEVEL_PUBLISHER": "Publisher",
  "USER_LEVEL_READER": "Reader",
  "USER_MANAGE_CATALOGS": "Manage Catalogs for Selected Users",
  "USER_MULT_USERS_SELECTED": "Multiple Users Selected",
  "USER_NAME": "User Name",
  "USER_NEW_USER_DETAILS": "New User Details",
  "USER_NEW_USER_INFO_MSG": "To add a user to specific catalogs, use Catalogs > Users.",
  "USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS": "Add user to all catalogs as:",
  "USER_NO_USERS_SELECTED": "No Users Selected",
  "USER_ONLINE": "Online",
  "USER_PASSWORD_TOO_SHORT": "Password must contain at least one character.",
  "USER_PASSWORDS_DO_NOT_MATCH": "The password confirmation field needs to match the password field.",
  "USER_ROLE": "Role",
  "USER_VIEW_DETAILS": "View/Edit User Details",
  "USERS": "Users",
  "VALIDATION_FIELD_LENGTH_EXCEEDED": "This field cannot exceed 255 characters.",
  "VALIDATION_MUST_BE_NONEMPTY": "This field is required.",
  "VIEW_EDIT_MAPPINGS": "View / Edit Mappings",
  "General.OK": "OK",
  "General.Cancel": "Cancel",
  "PORT_TITLE": "Ports",
  "PORT_DEFAULT": "Default:",
  "esp.port.admin-web-app": "Portfolio Admin HTTP Port",
  "esp.port.admin-web-app-ssl": "Portfolio Admin SSL Port",
  "esp.port.http": "Portfolio Server HTTP Port",
  "esp.port.ssl": "Portfolio Server SSL Port",
  "General.Save": "Save",
  "CATALOG_DETAILS_FILETYPES_TAB": "File Types",
  "addAsset": "Add Assets",
  "canManageFieldLists": "Manage Public Field Lists",
  "canModifyFolderStructure": "Modify Folder Structures",
  "canMoveAssets": "Move Assets",
  "deleteAssetContents": "Delete Original Assets",
  "deleteAssetFromCatalog": "Delete Asset from Catalog",
  "modifyAssetProperties": "Update Asset Fields",
  "synchronizeAutoSyncFolder": "Sync Autosync Folders",
  "ASSETS": "Assets",
  "CATALOG_STORAGE_TYPE_S3": "S3",
  "CREATE_CATALOG": "Create Catalog",
  "STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS": "The system memory is {value}GB which is below the {minGB}GB minimum requirements.",
  "STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE": "The system memory computed by Portfolio is {value}GB which may be inaccurate.",
  "AUTH.couldNotConnect": "Could not connect to the server. Please check the address.",
  "ERROR.serverUnavailable": "The Portfolio server is not available.",
  "ERROR.sessionExpired": "Your session has expired.",
  "fileNotFound": "The file was not found on disk.",
  "ERROR.invalidSearchFailed": "The search failed because there was a problem with the query.",
  "AUTH.loginFailed": "The username and password were incorrect.",
  "FAULT_CODE.InsufficientPrivileges": "You have insufficient privileges to perform this operation.",
  "unexpectedError": "An unexpected error occurred.",
  "ROLES_CREATE_ROLE_TITLE": "Create Role",
  "ROLES_DELETE_CONFIRM": "Do you want to delete the selected Role?\nUsers with this Role will be demoted to Readers.",
  "NOTIFICATION_SUCCESS_UPDATE": "Update Successful",
  "DATA_COLLECTION_TITLE": "Analytics",
  "DATA_COLLECTION_RTI_OPT_OUT_LABEL": "I agree to share application usage data.",
  "DATA_COLLECTION_RTI_OPT_OUT_TEXT": "Help us deliver the best solutions by sharing application usage with us.\n\nBy accepting, you'll help us gather important information that will guide us toward future quality and feature improvements. The information gathered helps us greatly understand your solution needs.\n\nYou can always change your mind at any time and discontinue sharing information.\n\nFor more information about how we use your information and to opt-out in the future please visit our help article page:",
  "DATA_COLLECTION_HELP_URL": "https://help.portfoliodam.com/hc/en-us/articles/1260804371029",
  "CREATE_USER": "Create User",
  "CATALOG_FILES_TAB_TITLE": "Ingest",
  "FIELD_CATEGORY_ALL": "All Active Fields",
  "FIELD_CATEGORY_FONTSENSE": "Portfolio DAM Font Sense",
  "FIELD_DEF.cataloged": "Cataloged",
  "FIELD_DEF.catalogedBy": "Cataloged By",
  "FIELD_DEF.colorMode": "Color Mode",
  "FIELD_DEF.isPanoramic": "Panoramic",
  "FIELD_DEF.created": "Created",
  "FIELD_DEF.directoryPath": "Directory Path",
  "FIELD_DEF.documentText": "Document Text",
  "FIELD_DEF.filename": "Filename",
  "FIELD_DEF.fileDescription": "Description",
  "FIELD_DEF.fileSize": "File Size",
  "FIELD_DEF.geometry": "Geo - Map",
  "FIELD_DEF.height": "Height",
  "FIELD_DEF.horizontalResolution": "Horizontal Resolution",
  "FIELD_DEF.keywords": "Keywords",
  "FIELD_DEF.lastModified": "Modified",
  "FIELD_DEF.lastUpdated": "Changed",
  "FIELD_DEF.aliasMac": "Alias Mac",
  "FIELD_DEF.creatorMac": "Creator Mac",
  "FIELD_DEF.fileTypeMac": "File Type Mac",
  "FIELD_DEF.zoneMac": "Zone Mac",
  "FIELD_DEF.multipageCount": "Number of Pages",
  "FIELD_DEF.numBands": "Number of Bands",
  "FIELD_DEF.path": "Path",
  "FIELD_DEF.ItemID": "Asset ID",
  "FIELD_DEF.shortFilenameWin": "Short Filename Win",
  "FIELD_DEF.thumbnailSize": "Thumbnail Size",
  "FIELD_DEF.updatedBy": "Changed By",
  "FIELD_DEF.verticalResolution": "Vertical Resolution",
  "FIELD_DEF.volume": "Volume",
  "FIELD_DEF.watermarkURL": "Watermark URL",
  "FIELD_DEF.watermarked": "Watermarked",
  "FIELD_DEF.width": "Width",
  "FIELD_DEF.SuggestedKeywords": "Smart Keywords",
  "REFRESH": "Refresh",
  "ALL_CATALOGS": "All Catalogs",
  "ALL_SITES": "All Sites",
  "ASSET_DOWNLOADS": "Assets - Most Downloaded",
  "ASSET_PREVIEWS": "Assets - Most Previewed",
  "ASSET_UPLOADS": "Assets - Uploads",
  "DOWNLOAD_REPORT": "Download Report",
  "FILE_TYPES": "File Types",
  "FILE_TYPES_SECTION_TITLE": "File Types",
  "FILE_TYPES_ERROR_NAME_EXISTS": "The name '{name}' matches the name of an existing file type.",
  "FILE_TYPES_LABEL_RESTORE_DEFAULTS": "Reset Defaults",
  "FILE_TYPES_PROMPT_DISCARD_CHANGES": "Discard pending changes?",
  "FILE_TYPES_ADD_FILE_TYPE": "Add File Type",
  "FILE_TYPES_UPDATE_FILE_TYPE": "Update File Type",
  "FILE_TYPES_EXTENSIONS": "Extensions",
  "FROM": "From",
  "SITE": "Site",
  "KEYWORD_STATISTICS": "Keyword Statistics",
  "NETPUBLISH_MOST_DOWNLOADED": "NetPublish - Most Downloaded",
  "NETPUBLISH_USAGE": "NetPublish - Usage",
  "REPORT_DESCRIPTION_ASSET_PREVIEWS": "This report identifies which assets were previewed and how many times each was previewed.",
  "REPORT_DESCRIPTION_ASSET_UPLOADS": "This report identifies uploaded assets, which users uploaded them, and when.",
  "REPORT_DESCRIPTION_DOWNLOADED": "This report identifies which assets were downloaded and how many times each was downloaded.",
  "REPORT_DESCRIPTION_KEYWORD": "This report identifies all the keywords in a catalog and how many assets they are applied to.",
  "REPORT_DESCRIPTION_USAGE": "This report identifies which users downloaded which assets, and when.",
  "SEARCH_TERMS": "Search Terms",
  "TO": "To",
  "VIEW_REPORT": "View Report",
  "NP_SITES": "NetPublish Sites",
  "REPORT_NAME_DELETED_BY": "Assets - Deletions",
  "REPORT_NAME_DOWNLOADED_BY": "Assets - Downloads",
  "REPORT_DESCRIPTION_DELETED_BY": "This report identifies deleted assets, which users deleted them, and when.",
  "REPORT_DESCRIPTION_DOWNLOADED_BY": "This report identifies downloaded assets, which users downloaded them, and when.",
  "CATALOG_SAVE_TEMPLATE_TITLE": "Save Catalog Template",
  "BACKUP_FILES_LABEL": "Backup Files",
  "CONFIGURE_EMAIL_LINK": "Configure email notifications...",
  "NP_SOURCE": "Source",
  "NOTIFICATION_FAILURE_UPDATE": "Update Unsuccessful",
  "FIELD_FORM_LABEL_PRECISION_MAX": "Max",
  "REPORT_DESCRIPTION_FILE_TYPES": "This report identifies your most common file types and how much disk space they occupy.",
  "REPORT_DESCRIPTION_SEARCH_TERMS": "This report identifies the most common words and phrases for which your users are searching in QuickFind.",
  "DUPLICATE_FIELD_NAME_ERROR": "Duplicate Field Name",
  "NO_CATALOGS_EXIST": "No Catalogs exist.\n\nClick the + button to create a Catalog.",
  "CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS": "Change {affectedUsersCount, plural, one {Role} other {Roles}}",
  "REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE": "Remove {affectedUsersCount, plural, one {User} other {{affectedUsersCount} Users}} from Catalog",
  "REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG": "Are you sure you want to remove the {affectedUsersCount, plural, one {user} other {selected users}} from the catalog?\n\nThe {affectedUsersCount, plural, one {user's} other {selected users'}} Checked Out items in this catalog will be reverted and made accessible.",
  "CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG": "Are you sure you want to change the {affectedUsersCount, plural, one {user's role} other {selected users' roles}} in the catalog?\n\nThis action can be destructive to the {affectedUsersCount, plural, one {user's} other {selected users'}} data if the new role has reduced access or permissions.",
  "DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE": "Querying\nThis may take a few minutes...",
  "FIELD_DELETE_CONFIRM_MSG": "Do you want to delete the selected field?",
  "FILE_TYPES_PROMPT_RESTORE_DEFAULTS": "Reset all FileTypes to their default values?",
  "DIRECTORY_SERVICE_BROWSE_FILTER_LABEL": "Filter",
  "DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL": "AD Users and Groups",
  "DIRECTORY_SERVICE_SAVE_MAPPINGS": "Save and Sync",
  "DIRECTORY_SERVICE_REMOVE_MAPPING": "Remove Mapping",
  "DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL": "Portfolio User Imports",
  "DIRECTORY_SERVICE_NO_MAPPINGS_LABEL": "No Mappings\n\nTo create a mapping, select a user or group to the left, and click 'Create Mapping'",
  "NOTIFICATION_FAILURE_ADD": "Add Unsuccessful",
  "FIELD_ADD_EXTRACT_METADATA": "Add Extract Metadata",
  "FIELD_MULTIPLE_EMBED_WARNING": "More than one field embeds to",
  "CATALOG_SK_KEYWORD_ON_CATALOG_LABEL": "Smart Keyword newly cataloged assets",
  "LIC_CLICK_TO_UPGRADE": "Click to upgrade Portfolio Server",
  "LIC_MAINTENANCE_END_DATE": "Maintenance/Subscription End Date",
  "LIC_SEAT_DISPLAY": "User Seats",
  "LIC_ACTIVATE": "Activate Portfolio",
  "LIC_CLICK_TO_ACTIVATE": "Activate Portfolio with your Portfolio DAM credentials",
  "LIC_CLICK_TO_USE": "Try Portfolio for a limited time with a Demo Serial Number",
  "LIC_TRIAL": "Try Portfolio",
  "EXTENSIS_CONTACT_US_URL": "https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option",
  "EXTENSIS_SUPPORT_URL": "https://help.portfoliodam.com/hc/en-us/requests/new",
  "LIC_ERROR_GET_ACCOUNT": "There was a problem getting your Portfolio DAM Account.",
  "LIC_ERROR_GET_LICENSES": "There was a problem retrieving your licenses from Portfolio DAM.",
  "CHANGE": "Change",
  "GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE": "To change this folder, first shut down Portfolio server",
  "MEDIA_ENGINES_COLUMN_TEST": "Test",
  "ROLES_PERMISSIONS": "Permissions",
  "NO_SITES_EXIST_1": "No NetPublish Sites exist.",
  "NO_SITES_EXIST_2": "Use the Publish option found within Portfolio to create and publish Sites.",
  "MEDIA_ENGINE_NOT_OPERATIONAL": "The media engine could not be accessed.",
  "MEDIA_ENGINE_OPERATIONAL": "The media engine is operational.",
  "LIC_SET_EXTENSIS_ACCOUNT": "Set Portfolio DAM Account",
  "LIC_ACCOUNT": "Email",
  "LIC_PASSWORD": "Password",
  "CERTS_TITLE": "SSL Certificate",
  "LIC_SYSTEM_ID": "System ID",
  "LIC_SET_ACCOUNT_ERROR": "There was a problem setting your Portfolio DAM Account. Please check the credentials and try again.",
  "LIC_SET_SYSTEM_TITLE": "Select Your Portfolio DAM System",
  "NP_DELETE_SITE_CONFIRMATION": "Do you want to permanently delete the Site?",
  "NP_SITE_DELETE_LABEL": "Delete Site",
  "NP_SITE_ENABLED_LABEL": "Site Enabled",
  "CERT_CREATE_REQUEST": "Create Certificate Request",
  "CERT_DOWNLOAD": "Download",
  "CERT_EXPIRATION_DATE": "Expiration Date",
  "CERT_IMPORT": "Import Certificate",
  "CERT_ISSUER": "Issuer",
  "CERT_OWNER": "Owner",
  "CERT_PENDING_REQUEST": "Pending Certificate Request",
  "CERTIFICATE_STATUS_INVALID": "Invalid Certificate",
  "CERTIFICATE_STATUS_SELF_SIGNED": "Invalid Certificate: Self-Signed",
  "CERTIFICATE_STATUS_EXPIRED": "Certificate Expired",
  "CERTIFICATE_STATUS_IMPORTED": "Certificate Imported",
  "CERT_DELETE_CONFIRMATION": "Are you sure you want to delete the certificate request? This cannot be undone.",
  "DIAGNOSTICS_TITLE": "Diagnostics",
  "DIAGNOSTICS_NO_PROBLEMS": "No problems found",
  "SK_ENGINE_ART_STYLE": "Art Style",
  "SK_ENGINE_ART_SUBJECT": "Art Subject",
  "SK_ENGINE_ART_MOVEMENT": "Art Movement",
  "CERT_FILE": "Certificate File",
  "CERT_FILE_INT_1": "Intermediate Certificate 1",
  "CERT_FILE_INT_2": "Intermediate Certificate 2",
  "CERT_FILE_PASSWORD": "Certificate Password",
  "CERT_FILE_PASSWORD_HELP": "If your certificate has a password, enter it here",
  "CERT_FILE_PROMPT": "Select...",
  "CERT_FILE_ROOT": "Root Certificate",
  "CERT_IMPORT_SUCCEEDED": "The certificate was successfully imported. Please restart the Portfolio server and Portfolio admin services to begin using the certificate.",
  "CERT_IMPORT_FAILED_READING_PKCS12": "The server could not read the PKCS12 certificate. Check the password.",
  "CERT_IMPORT_FAILED_INTERMEDIATE1": "The Intermediate 1 certificate could not be imported.",
  "CERT_IMPORT_FAILED_INTERMEDIATE2": "The Intermediate 2 certificate could not be imported.",
  "CERT_IMPORT_FAILED_ROOT": "The root certificate could not be imported.",
  "DIRECTORY_SERVICE_CONFIG_TITLE": "Active Directory Configuration",
  "DIRECTORY_SERVICES_TITLE": "Directory Services",
  "DIRECTORY_SERVICE_MAPIINGS": "Directory Items to Portfolio Mappings",
  "DIRECTORY_SERVICE_MAPIINGS_TITLE": "Mappings",
  "PDL_noPredefinedValues": "No Predefined Values",
  "PDL_editPredefinedListPlaceholder": "Edit Predefined List",
  "PDL_importPredefinedValues": "Import Predefined Values",
  "PDL_exportPredefinedValues": "Export Predefined Values",
  "PDL_removeNestedValueConfirmation": "Delete the selected values?\nThey contain nested values which will also be deleted.",
  "PDL_wrongPdlImportFormat": "The selected file did not contain text data. Please select a text file.",
  "LIC_SET_ACCOUNT": "Set Account",
  "LIC_REMOVE_ACCOUNT": "Remove Account",
  "LIC_CONTACT_CUSTOMER_SUCCESS_1": "For assistance with renewing your account, please contact us at",
  "LIC_CONTACT_CUSTOMER_SUCCESS_2": "and your Customer Success Manager will contact you within 1 business day."
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/translations/en.js